import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
import React from "react";
import PropTypes from "prop-types";
import { SPACE } from "@xo-union/constant-key-codes";
import { useClassesMapper, compose } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import momentPropTypes from "react-moment-proptypes";
import OutsideClickHandler from "@xo-union/component-outside-click";
import moment from "moment";
import noop from "lodash/noop";
import DatePicker from "../DatePicker/index.js";
import styles from "../../css/styles.css";
var newStyles = compose({
  container: styles['absolute-container']
});

var DatePickerDropdown = function DatePickerDropdown(props) {
  var date = props.date,
      dateFormat = props.dateFormat,
      onDateChange = props.onDateChange,
      renderInput = props.renderInput,
      classesProp = props.classes,
      rest = _objectWithoutProperties(props, ["date", "dateFormat", "onDateChange", "renderInput", "classes"]);

  var classes = useClassesMapper(newStyles, classesProp);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isOpen = _React$useState2[0],
      setOpen = _React$useState2[1];

  var close = React.useCallback(function () {
    setOpen(false);
  }, []);
  var open = React.useCallback(function () {
    setOpen(true);
  }, []);
  var toggle = React.useCallback(function () {
    setOpen(function (v) {
      return !v;
    });
  }, []);
  var handleKey = React.useCallback(function (evt) {
    if (evt.keyCode === SPACE) {
      toggle();
      evt.preventDefault();
    }
  }, [toggle]);
  var handleChange = React.useCallback(function (evt) {
    props.onDateChange(evt);
    close();
  }, [props.onDateChange, close]);
  var dateString = date && moment(date).format(dateFormat) || '';
  return React.createElement(OutsideClickHandler, {
    onOutsideClick: close
  }, renderInput({
    onClick: open,
    onKeyDown: handleKey,
    value: dateString
  }), isOpen && React.createElement(DatePicker, _extends({
    classes: classes,
    date: date,
    onDateChange: handleChange
  }, rest)));
};

DatePickerDropdown.defaultProps = {
  onDateChange: noop,
  dateFormat: 'YYYY-MM-DD'
};
process.env.NODE_ENV !== "production" ? DatePickerDropdown.propTypes = {
  /**
   * Moment date object or null.
   */
  date: momentPropTypes.momentObj,

  /**
   * Date format to use for field value
   */
  dateFormat: PropTypes.string,

  /**
   * Render function for input, it received input props as the first argument
   */
  renderInput: PropTypes.func.isRequired,

  /**
   * Callback for when date changes
   */
  onDateChange: PropTypes.func,

  /**
   * Classes dependencies. Supports all the same classes as DatePicker
   */
  classes: classesPropType([])
} : void 0;
export default DatePickerDropdown;